export interface GetClassificationRequest {
    /** 任务ID */
    task_id: string;
    /** 操作类型 */
    operate_type?: string;
}

export interface GetClassificationResponse {
    /** 分类号列表 */
    classification: string[];
}

export const GetClassificationApi = Symbol.for('GetClassificationApi');

export interface GetClassificationApi {
    getClassification(data: GetClassificationRequest, options?: { single: AbortSignal }): Promise<GetClassificationResponse>;
}
